import React, { useContext } from 'react';
import EditText from '../crm/shared/field_inputs/text/EditText';
import { HandleAddTeacher } from './requests/TeacherRequests';
import EditSelect from '../crm/shared/field_inputs/select/EditSelect';
import { getOptionsObjectValues, teacherCompensationTypeOptions } from './shared/translations';
import { DataContext as SharedDataContext } from '../../stores/crm-store';
import { navigate } from 'hookrouter';
import ExlEditDraft from './field_inputs/ExlEditDraft';
import ExlCourseFormModal from './shared/ExlCourseFormModal';
import Checkbox from '../Checkbox';
import { useTranslation } from 'react-i18next';
import { ADD_TEACHER_BUTTON_LABEL, ADD_TEACHER_LABEL, EMAIL_NOTIFICATIONS_FALSE, EMAIL_NOTIFICATIONS_TRUE, TEACHER_MODALS_COMP_TYPE_LABEL, TEACHER_MODALS_DESC_LABEL, TEACHER_MODALS_EMAIL_LABEL, TEACHER_MODALS_EMAIL_NOTI_LABEL, TEACHER_MODALS_INVALID_EMAIL_VALI, TEACHER_MODALS_NAME_LABEL, TEACHER_MODALS_NO_COMP_TYPE_VALI, TEACHER_MODALS_NO_NAME_VALI } from '../../i18n/keyConstants';

const AddTeacher = () => {
    const { dispatch: sharedDispatch } = useContext(SharedDataContext);
    const { t } = useTranslation(['addTeacher', 'teacherModals', 'shared']);
    let label = t(ADD_TEACHER_BUTTON_LABEL)

    const formComponents = [
        {
            propName: 'name',
            label: t(TEACHER_MODALS_NAME_LABEL, {ns: 'teacherModals'}),
            validate: (v) => (!v || !v.length ? t(TEACHER_MODALS_NO_NAME_VALI, {ns: 'teacherModals'}) : ''),
            component: <EditText />,
        },
        {
            propName: 'email',
            label: t(TEACHER_MODALS_EMAIL_LABEL, {ns: 'teacherModals'}),
            validate: (v) => (!v || !v.length || !validateEmail(v) ? t(TEACHER_MODALS_INVALID_EMAIL_VALI, {ns: 'teacherModals'}) : ''),
            component: <EditText />,
        },
        {
            propName: 'description',
            label: t(TEACHER_MODALS_DESC_LABEL, {ns: 'teacherModals'}),
            component: <ExlEditDraft />,
        },
        {
            propName: 'compensationType',
            label: t(TEACHER_MODALS_COMP_TYPE_LABEL, {ns: 'teacherModals'}),
            validate: (v) => (!v ? t(TEACHER_MODALS_NO_COMP_TYPE_VALI, {ns: 'teacherModals'}) : ''),
            component: <EditSelect options={getOptionsObjectValues(teacherCompensationTypeOptions)} />
        },
        {
            propName: 'receiveEmailNotifications',
            label: '',
            component: <Checkbox 
                            usedInExl={true} 
                label={t(TEACHER_MODALS_EMAIL_NOTI_LABEL, {ns: 'teacherModals'})}
                          />
        }
    ];

    const validateEmail = (email) => {
        let correctEmail = true;
      
        if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)) {
            correctEmail = false;
        }
      
        return correctEmail;
      }

    const handleAdd = async (teacher) => {
        teacher.compensationType = teacher.compensationType.value;
        const response = await HandleAddTeacher(teacher);
        if (response.success) {
            sharedDispatch({ type: 'SHOW_SAVED_TOAST' })
            navigate('/exlTeacherDetails/' + response.data.id);
        }
        return response;
    };
 
    return (
        <ExlCourseFormModal
            label={label}
            description={t(ADD_TEACHER_LABEL)}
            defaultFormComponents={formComponents}
            handleAdd={handleAdd}
            isExl
            trueText={t(EMAIL_NOTIFICATIONS_TRUE, {ns: 'shared'})}
            falseText={t(EMAIL_NOTIFICATIONS_FALSE, {ns: 'shared'})}
            tooltipPlace={'left'}
        />
    );
};

export default AddTeacher;